import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';
import script from './HseButton.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,{tag:"component",staticClass:"hse-Button",class:( _obj = {}, _obj[("hse-Button_variant_" + _vm.variant)] = _vm.variant, _obj[("hse-Button_size_" + _vm.size)] = _vm.size, _obj['hse-Button_inactive'] =  _vm.inactive, _obj['hse-Button_disabled'] =  _vm.disabled, _obj['hse-Button_selected'] =  _vm.selected, _obj['hse-Button_focused'] =  _vm.focused, _obj['hse-Button_custom-color'] =  !!_vm.color, _obj['hse-Button_hasSpinner'] =  _vm.spinner && _vm.spinnerPosition, _obj['hse-Button_hasLeft'] =  _vm.hasLeft, _obj['hse-Button_hasRight'] =  _vm.hasRight, _obj['hse-Button_hasSideContent'] =  _vm.hasLeft || _vm.hasRight, _obj[("hse-Button_spinner_" + _vm.spinner)] = _vm.spinner, _obj ),style:(_vm.colorStyle),attrs:{"disabled":_vm.disabled},on:{"blur":_vm.onBlur,"click":_vm.onClick,"focus":_vm.onFocus,"keydown":_vm.interactionBubbles.onKeyDown,"mousedown":_vm.interactionBubbles.onMouseDown}},[_c('div',{ref:"buttonBubble",staticClass:"hse-Button__bubbleRoot"}),_vm._v(" "),_c('div',{staticClass:"hse-Button__content"},[(_vm.hasLeft)?_c('div',{staticClass:"hse-Button__contentLeft"},[_vm._t("left",[(!_vm.spinner && _vm.leftIconComputed)?_c('HseIcon',{staticClass:"hse-Button__icon hse-Button__icon_left",attrs:{"icon":_vm.leftIconComputed,"size":_vm.iconSize}}):(_vm.isSpinnerLeft)?_c('HseSpinner',_vm._b({staticClass:"hse-Button__spinner hse-Spinner_without-done-fill-animation",class:{
            'hse-Button__spinner_left': _vm.spinnerPosition === 'left'
          }},'HseSpinner',_vm.spinnerProps,false)):_vm._e()])],2):_vm._e(),_vm._v(" "),[(_vm.isSpinnerDefault)?_c('HseSpinner',_vm._b({staticClass:"hse-Button__spinner hse-Spinner_without-done-fill-animation"},'HseSpinner',_vm.spinnerProps,false)):_c('div',{staticClass:"hse-Button__text"},[_vm._t("default")],2)],_vm._v(" "),(_vm.hasRight)?_c('div',{staticClass:"hse-Button__contentRight"},[_vm._t("right",[(!_vm.spinner && _vm.rightIconComputed)?_c('HseIcon',{staticClass:"hse-Button__icon hse-Button__icon_right",attrs:{"icon":_vm.rightIconComputed,"size":_vm.iconSize}}):(_vm.isSpinnerRight)?_c('HseSpinner',_vm._b({staticClass:"hse-Button__spinner hse-Button__spinner_right hse-Spinner_without-done-fill-animation"},'HseSpinner',_vm.spinnerProps,false)):_vm._e()])],2):_vm._e()],2)])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
